module.exports = __webpack_public_path__ + "assets/warning.bb78c42b.svg";